import { render } from "./AddManufacturer.vue?vue&type=template&id=fd273820&ts=true"
import script from "./AddManufacturer.vue?vue&type=script&lang=ts"
export * from "./AddManufacturer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__